// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectionBoxWrapper_selectionBoxContainer__Skouv {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportConfigurator/SelectionBoxWrapper.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AACF","sourcesContent":[".selectionBoxContainer {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionBoxContainer": `SelectionBoxWrapper_selectionBoxContainer__Skouv`
};
export default ___CSS_LOADER_EXPORT___;
